// Utils
import classnames from 'classnames'

import Button, { ButtonProps } from '../button'
import { BUTTON_SIZE, BUTTON_TYPES } from '../button/button.constants'

import styles from './buttonGroup.module.scss'

export interface ButtonGroupProps {
  buttons?: ButtonProps[]
  className?: string
  sendEventOnButtonClick: (...args: any) => void
}

const ButtonGroup = ({ buttons = [], className, sendEventOnButtonClick }: ButtonGroupProps) => {
  const classes = classnames(styles.wrapper, className)
  return (
    <div className={classes}>
      {buttons.map(button => {
        return (
          <Button
            {...button}
            type={BUTTON_TYPES.SQUARE}
            size={BUTTON_SIZE.SQUARE}
            round={false}
            key={button.id}
            className={styles.wrapper__button}
            onClick={() => {
              sendEventOnButtonClick(button.children, buttons)
            }}
          >
            {button.children}
          </Button>
        )
      })}
    </div>
  )
}

export default ButtonGroup
